import { Dispatch, SetStateAction, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function SelectStore({ open, onClose, setOpen }: ModalProps) {
  const [selectedStore, setSelectedStore] = useState<number | null>(null);

  const stores = [1, 2, 3, 4];

  const handleSelect = (store: number) => {
    setSelectedStore(store);
  };

  const handleSubmit = () => {
    setOpen(false);
  };

  return (
    <Modal className="modal addReply_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Select Store</h2>
            <button
              type="button"
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </button>
          </div>

          <div className="store_card_container">
            {stores.map((store) => (
              <div
                key={store}
                className={`store_card ${
                  selectedStore === store ? "selected" : ""
                }`}
                onClick={() => handleSelect(store)}
              >
                Store {store}
              </div>
            ))}
          </div>

          <div className="footer_btn_flex">
            <Button className="btn btn_grey" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              className="btn btn_primary"
              disabled={!selectedStore}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
